const breakpoints = {
    0: 'xs',
    576: 'sm',
    768: 'md',
    992: 'lg',
    1200: 'xl',
    1400: 'xxl',
  };
  
  export default breakpoints;